import { z } from "zod";

/** Programme request shapes — docs/03-API-SPEC.md §4. */

const slugSchema = z
  .string()
  .min(1)
  .max(80)
  .regex(/^[a-z][a-z0-9-]*$/, "Use lowercase letters, numbers and hyphens, starting with a letter");

/**
 * The states a programme runs in, by name. Empty means every state, which is what Scholarship
 * needs; a short list is what the state-restricted programmes need, and it is the default offered
 * when a form's State/LGA field is restricted.
 */
const areaStatesSchema = z.array(z.string().trim().min(1).max(60)).max(40);

export const programmeCreateRequestSchema = z.object({
  name: z.string().min(1).max(200),
  slug: slugSchema,
  description: z.string().max(2000).nullable().optional(),
  brandProfileId: z.string().nullable().optional(),
  retentionYears: z.number().int().min(1).max(50).default(7),
  areaStates: areaStatesSchema.optional(),
});

export const programmeUpdateRequestSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  description: z.string().max(2000).nullable().optional(),
  brandProfileId: z.string().nullable().optional(),
  retentionYears: z.number().int().min(1).max(50).optional(),
  areaStates: areaStatesSchema.optional(),
  isActive: z.boolean().optional(),
});

export type ProgrammeCreateRequest = z.infer<typeof programmeCreateRequestSchema>;
export type ProgrammeUpdateRequest = z.infer<typeof programmeUpdateRequestSchema>;
